import { useSelector } from 'react-redux';
import { DEFAULT_SHIPPING_ONLY_PARTNER_PARENT_COUPONS } from '../lib/shippingOnlyPartnerOffer';
import * as types from '../types';

export default function useShippingOnlyPartnerParentCoupons() {
  return useSelector(
    (state: types.AppState) =>
      state.config.siteConfig.shippingOnlyPartnerParentCoupons ?? DEFAULT_SHIPPING_ONLY_PARTNER_PARENT_COUPONS,
  );
}
